module.exports = __webpack_public_path__ + "static/media/email-confirmation-icon.9962cf69.svg";